<template>
    <div class="vacancies-page nr_container_content ">

        <h1 class="page-title">
            Ключевые вакансии
        </h1>

        <div class="search-row">

            <div class="search-box">

                <v-text-field
                        v-model="search"
                        hide-details
                        solo
                        flat
                        placeholder="Поиск вакансии"
                        class="search-input"
                />

                <button class="search-btn">
                    <v-icon color="white">
                        mdi-magnify
                    </v-icon>
                </button>

            </div>

        </div>

        <div class="layout">

            <!--бар-->
            <aside class="sidebar">

                <div class="sidebar-header">

                    <div class="sidebar-title">Фильтры</div>
                    <button
                            v-if="isFilterActive"
                            class="reset-btn"
                            @click="resetFilters"
                    >
                        Сбросить фильтр
                    </button>
                </div>
                <div class="filter-section__wrapper">
                    <div
                            v-for="filter in filters"
                            :key="filter.id"
                            class="filter-section"
                    >

                        <div class="filter-section__title">
                            {{ filter.title }}
                        </div>

                        <!-- RADIO -->
                        <template v-if="filter.type === 'radio'">

                            <v-radio-group
                                    v-model="filterValues[filter.id]"
                                    hide-details
                                    class="radio-group"

                            >
                                <v-radio
                                        v-for="item in filter.items"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        color="red"
                                />
                            </v-radio-group>

                        </template>

                        <!-- CHECKBOX -->
                        <template v-if="filter.type === 'checkbox'">

                            <v-checkbox
                                    v-for="item in getVisibleItems(filter)"
                                    :key="item.value"
                                    v-model="filterValues[filter.id]"
                                    :value="item.value"
                                    :label="item.label"
                                    hide-details
                                    class="checkbox-item"
                                    color="red"
                            />

                            <button
                                    v-if="
                  filter.showMore &&
                  filter.items.length > (filter.visibleCount || 5)
                "
                                    class="show-more"
                                    @click="toggleFilter(filter.id)"
                            >
                                {{
                                expandedFilters[filter.id]
                                    ? 'Скрыть'
                                    : 'Показать еще'
                                }}
                            </button>

                        </template>

                    </div>
                </div>


            </aside>

            <!-- конент -->
            <section class="content">

                <div class="vacancies-counter">
                    Найдено {{ filteredVacancies.length }} вакансий
                </div>

                <div
                        v-for="vacancy in filteredVacancies"
                        :key="vacancy.id"
                        class="vacancy-card position-relative"
                >
                    <a :href="vacancy.url" class="position-absolute t-0 l-0 w-100 h-100 zi-1"></a>

                    <div class="vacancy-meta">

                        <div class="meta-item" v-if="vacancy.city">

                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path data-v-5d514390=""
                                      d="M18.364 17.3639L12 23.7279L5.636 17.3639C4.37734 16.1052 3.52019 14.5016 3.17293 12.7558C2.82567 11.0099 3.00391 9.20035 3.6851 7.55582C4.36629 5.91129 5.51984 4.50569 6.99988 3.51677C8.47992 2.52784 10.22 2 12 2C13.78 2 15.5201 2.52784 17.0001 3.51677C18.4802 4.50569 19.6337 5.91129 20.3149 7.55582C20.9961 9.20035 21.1743 11.0099 20.8271 12.7558C20.4798 14.5016 19.6227 16.1052 18.364 17.3639ZM12 14.9999C13.0609 14.9999 14.0783 14.5785 14.8284 13.8283C15.5786 13.0782 16 12.0608 16 10.9999C16 9.93906 15.5786 8.92164 14.8284 8.17149C14.0783 7.42135 13.0609 6.99992 12 6.99992C10.9391 6.99992 9.92172 7.42135 9.17158 8.17149C8.42143 8.92164 8 9.93906 8 10.9999C8 12.0608 8.42143 13.0782 9.17158 13.8283C9.92172 14.5785 10.9391 14.9999 12 14.9999ZM12 12.9999C11.4696 12.9999 10.9609 12.7892 10.5858 12.4141C10.2107 12.0391 10 11.5304 10 10.9999C10 10.4695 10.2107 9.96078 10.5858 9.58571C10.9609 9.21064 11.4696 8.99992 12 8.99992C12.5304 8.99992 13.0391 9.21064 13.4142 9.58571C13.7893 9.96078 14 10.4695 14 10.9999C14 11.5304 13.7893 12.0391 13.4142 12.4141C13.0391 12.7892 12.5304 12.9999 12 12.9999Z"
                                      fill="#FA4237"></path>
                            </svg>

                            {{ vacancy.city }}

                        </div>

                        <div class="meta-item" v-if="vacancy.experience">

                            <svg class="mr-1" width="20" height="18" viewBox="0 0 20 18" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                        d="M13 0C13.552 0 14 0.448 14 1V3H19C19.552 3 20 3.448 20 4V17C20 17.552 19.552 18 19 18H1C0.448 18 0 17.552 0 17V4C0 3.448 0.448 3 1 3H6V1C6 0.448 6.448 0 7 0H13ZM6 5H4V16H6V5ZM16 5H14V16H16V5ZM12 2H8V3H12V2Z"
                                        fill="#FA4237"/>
                            </svg>


                            {{ vacancy.experience }}

                        </div>

                    </div>

                    <div class="vacancy-title">
                        {{ vacancy.title }}
                    </div>

                    <div class="tags">

                        <div
                                v-for="tag in vacancy.tags"
                                :key="tag"
                                class="tag"
                        >
                            {{ tag }}
                        </div>

                    </div>

                </div>

            </section>

        </div>

    </div>
</template>

<script>
export default {
    name: "VacanciesPage",

    props: {

        datafilters: {
            type: [String, Number, Boolean, Object, Array],
            default: () => []
        },

        datavacancies: {
            type: [String, Number, Boolean, Object, Array],
            default: () => []
        },
        datafiltervalues: {
            type: [String, Number, Boolean, Object, Array],
            default: () => ({})
        }
    },

    data() {
        return {

            filters: this.datafilters,
            // origin
            // filters: [
            //   {
            //     id: "direction",
            //     title: "Направления",
            //     type: "radio",
            //     items: [
            //       {value: "all", label: "Все"},
            //       {value: "prod", label: "Производство"},
            //       {value: "office", label: "Офис"},
            //       {value: "boss", label: "Руководящие позиции"}
            //     ]
            //   },
            //
            //   {
            //     id: "city",
            //     title: "Город",
            //     type: "checkbox",
            //     showMore: true,
            //     visibleCount: 5,
            //     items: [
            //       {value: 1, label: "Город 1"},
            //       {value: 2, label: "Город 2"},
            //       {value: 3, label: "Город 3"},
            //       {value: 4, label: "Город 4"},
            //       {value: 5, label: "Город 5"},
            //       {value: 6, label: "Город 6"}
            //     ]
            //   },
            //
            //   {
            //     id: "keyskills",
            //     title: "Ключевые навыки",
            //     type: "checkbox",
            //     showMore: true,
            //     visibleCount: 5,
            //     items: [
            //       {value: 1, label: "Обучаемость"},
            //       {value: 2, label: "Работа в команде"},
            //       {value: 3, label: "Знание 1С"},
            //       {value: 4, label: "Уверенный пользователь Excel"},
            //       {value: 5, label: "Развитие процесса продаж"},
            //       {value: 6, label: "Тестовый пт 6"},
            //       {value: 7, label: "Тестовый пт 7"}
            //     ]
            //   }
            // ],


            vacancies: this.datavacancies,
            // origin
            // vacancies: [
            //   {
            //     id: 1,
            //     url: "",
            //     city: "Дзержинск",
            //     experience: "Более 5 лет",
            //     title: "Мастер отдела главного энергетика",
            //     tags: [
            //       "Работа в команде",
            //       "Уверенный пользователь Excel"
            //     ]
            //   }
            // ],

            search: "",
            debouncedSearch: "",
            searchDebounceTimer: null,

            filterValues: {},

            expandedFilters: {}
        };
    },

    beforeDestroy() {
        if (this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer);
        }
    },

    watch: {
        filters: {
            immediate: true,
            deep: true,
            handler() {
                this.initializeFilters();
            }
        },

        datafiltervalues: {
            deep: true,
            handler() {
                this.initializeFilters(true);
            }
        },

        filterValues: {
            deep: true,
            immediate: true,
            handler() {
                this.triggerSelectionChange();
            }
        },

        search() {
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }

            this.searchDebounceTimer = setTimeout(() => {
                this.debouncedSearch = this.search;
                this.triggerSelectionChange();
            }, 300);
        }
    },

    computed: {
        isFilterActive() {
            const directionValue = this.filterValues['direction'];
            if (directionValue && directionValue !== 'all') {
                return true;
            }

            const hasActiveCheckboxes = Object.keys(this.filterValues).some(key => {
                const value = this.filterValues[key];
                return Array.isArray(value) && value.length > 0;
            });
            if (hasActiveCheckboxes) {
                return true;
            }

            if (this.search.trim() !== '') {
                return true;
            }

            return false;
        },

        filteredVacancies() {
            let result = [...this.vacancies];

            if (this.debouncedSearch) {
                const query = this.debouncedSearch.toLowerCase();

                result = result.filter(item =>
                    item.title.toLowerCase().includes(query)
                );
            }

            return result;
        }
    },

    methods: {

        getParsedFilterValues() {
            const raw = this.datafiltervalues;

            if (!raw) {
                return {};
            }

            if (typeof raw === "string") {
                try {
                    return JSON.parse(raw);
                } catch (e) {
                    return {};
                }
            }

            return raw;
        },

        getPresetValue(filter) {
            const preset = this.getParsedFilterValues()[filter.id];

            if (filter.type === "radio") {
                if (preset === undefined || preset === null || preset === "") {
                    return "all";
                }

                return preset;
            }

            if (filter.type === "checkbox") {
                return Array.isArray(preset) ? [...preset] : [];
            }

            return preset;
        },

        hasHiddenSelectedItems(filter, selectedValues) {
            if (
                !filter.showMore ||
                !Array.isArray(selectedValues) ||
                !selectedValues.length
            ) {
                return false;
            }

            const visibleCount = filter.visibleCount || 5;
            const visibleValues = filter.items
                .slice(0, visibleCount)
                .map(item => String(item.value));

            return selectedValues.some(
                value => !visibleValues.includes(String(value))
            );
        },

        initializeFilters(fromProp = false) {
            const values = {};
            const expanded = {};
            const filters = Array.isArray(this.filters) ? this.filters : [];
            const currentValues = this.filterValues || {};

            filters.forEach(filter => {
                if (!fromProp && currentValues[filter.id] !== undefined) {
                    values[filter.id] = Array.isArray(currentValues[filter.id])
                        ? [...currentValues[filter.id]]
                        : currentValues[filter.id];
                } else {
                    values[filter.id] = this.getPresetValue(filter);
                }

                expanded[filter.id] = this.hasHiddenSelectedItems(
                    filter,
                    values[filter.id]
                );
            });

            this.filterValues = values;
            this.expandedFilters = expanded;
        },

        getVisibleItems(filter) {
            if (
                !filter.showMore ||
                this.expandedFilters[filter.id]
            ) {
                return filter.items;
            }

            return filter.items.slice(
                0,
                filter.visibleCount || 5
            );
        },

        toggleFilter(filterId) {
            this.$set(
                this.expandedFilters,
                filterId,
                !this.expandedFilters[filterId]
            );
        },

        resetFilters() {
            this.initializeFilters(true);

            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
                this.searchDebounceTimer = null;
            }

            this.search = "";
            this.debouncedSearch = "";
        },


        triggerSelectionChange() {

            console.log("triggerSelectionChange search", this.search);
            const selectedItems = [];

            this.filters.forEach(filter => {

                const currentValue = this.filterValues[filter.id];

                // radio
                if (filter.type === 'radio' && currentValue) {

                    const selected = filter.items.find(
                        item => String(item.value) === String(currentValue)
                    );

                    if (selected) {
                        selectedItems.push({
                            filterId: filter.id,
                            filterTitle: filter.title,
                            type: filter.type,
                            ...selected
                        });
                    }
                }

                // checkbox
                if (
                    filter.type === 'checkbox' &&
                    Array.isArray(currentValue)
                ) {

                    filter.items.forEach(item => {

                        if (currentValue.some(value => String(value) === String(item.value))) {

                            selectedItems.push({
                                filterId: filter.id,
                                filterTitle: filter.title,
                                type: filter.type,
                                ...item
                            });

                        }

                    });

                }

            });

            this.onFiltersChange(selectedItems);

        },

        onFiltersChange(selectedItems) {

            console.log("onFiltersChange", selectedItems);

            // фитч
            let url = "/ajax/vacancies-search.php";
            let params = new URLSearchParams();
            params.set("selectedItems", JSON.stringify(selectedItems));
            params.set("ajaxPost", "Y");

            fetch(url, {method: "POST", body: params})
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if (data && data.vacancies) {
                        this.vacancies = data.vacancies;
                    }
                });

        },
    }
};
</script>

<style scoped lang="scss">

.vacancies-page {
  background: #fff;


  .page-title {
    margin: 0 0 28px;

    font-size: 60px;
    font-weight: 700;
    line-height: 1;

    color: #fa4237;

    font-family: "MuseoSansCyrl-600";

    @media (max-width: 1200px) {
      font-size: 40px;
    }

    @media (max-width: 767px) {
      font-size: 35px;
    }
  }

  .search-row {
    margin-bottom: 26px;
  }

  .search-box {
    position: relative;
  }

  .search-btn {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background: #fa4237;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 5;

    @media (max-width: 768px) {
      width: 60px;
      height: 60px;
    }

    & .v-icon.v-icon {
      font-size: 34px;
    }
  }

  .layout {
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 34px;
  }

  .sidebar-title {
    font-size: 28px;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: 0px;
    font-family: "RobotoMedium";
  }

  .sidebar-header {
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: space-between;
    margin-bottom: 28px;
  }

  .reset-btn {
    font-size: 16px;
    line-height: 20px;
    color: #FA4237;
    font-family: "RobotoRegular";
    text-decoration: underline dotted;
  }

  .filter-section {
    margin-bottom: 28px;
  }

  .filter-section__title {
    margin-bottom: 12px;
    font-family: "RobotoMedium";
    font-size: 20px;
    font-weight: 500;
    line-height: 120%;
    letter-spacing: 0px;
    color: #121315;
  }

  .filter-section__wrapper {
    @media (max-width: 1200px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    @media (max-width: 425px) {
      grid-template-columns: 1fr;
    }
  }

  .show-more {
    margin-top: 8px;

    font-size: 14px;
    color: #fa4237;
  }

  .content {
    min-width: 0;
  }

  .vacancies-counter {
    text-align: right;

    color: #999;
    font-size: 20px;

    margin-bottom: 14px;
  }

  .vacancy-card {
    border: 1px solid #ededed;
    border-radius: 24px;

    padding: 20px 24px;

    margin-bottom: 16px;

    transition: .2s;
  }

  .vacancy-card:hover {
    border-color: #dddddd;
  }

  .vacancy-meta {
    display: flex;
    gap: 25px;
    margin-bottom: 16px;
    flex-wrap: wrap;

    @media (max-width: 425px) {
      gap: 15px;
    }
  }

  .meta-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: "MuseoSansCyrl-500";
    color: #fa4237;
    font-size: 20px;

    @media (max-width: 1200px) {
      font-size: 17px;
    }

    @media (max-width: 767px) {
      font-size: 14px;
    }
  }

  .vacancy-title {
    font-size: 35px;
    font-weight: 500;
    line-height: 30px;
    font-family: "MuseoSansCyrl-500";
    color: #232323;

    margin-bottom: 21px;
    @media (max-width: 1200px) {
      font-size: 28px;
    }

    @media (max-width: 767px) {
      font-size: 23px;
    }
  }

  .tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .tag {
    background: #f2f2f2;

    border-radius: 999px;

    padding: 7px 14px;
    font-family: "RobotoRegular";
    font-size: 16px;
    color: #666;

    @media (max-width: 1200px) {
      font-size: 14px;
    }

    @media (max-width: 767px) {
      font-size: 12px;
    }
  }

  ::v-deep .search-input .v-input__slot {
    min-height: 48px !important;
    border-radius: 64px !important;
    border: 1px solid #e6e6e6 !important;
    box-shadow: none !important;
    padding: 30px 12px 30px 32px !important;

    @media (max-width: 768px) {
      padding: 20px 12px 20px 20px !important;
    }

    ::placeholder {
      font-family: "RobotoRegular";
      font-weight: 400;
      font-size: 20px;
      line-height: 120%;
      letter-spacing: 0px;
      color: #4C4C4C !important;
    }
  }


  ::v-deep .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }

  ::v-deep .v-label {
    font-size: 18px;
    font-family: 'RobotoRegular';
    line-height: 120%;
    color: #121315;
    margin-bottom: 0;
  }


  ::v-deep .v-radio {
    margin-bottom: 4px;
  }

  ::v-deep .v-input--checkbox {
    margin-bottom: 4px;
  }

  @media (max-width: 1200px) {
    .layout {
      grid-template-columns: 1fr;
    }

    .vacancies-counter {
      text-align: left;
      font-family: 'RobotoRegular';
    }
  }
}
</style>